module.exports = __webpack_public_path__ + "img/loading.edc2a8b0.gif";